import React from 'react';
import classNames from 'classnames';
import './FlyOutMenu.less';
import { IDesignerAction } from 'domains/designers/common/DesignerActions/DesignerAction';
import { DesignerActions } from 'domains/designers/common';

export interface IFlyOutMenuProps extends React.ComponentPropsWithoutRef<'div'> {
  actions: IDesignerAction[];
}

/**
 * Menu is on the top of designer surface.
 * It is supposed to be used for steps/elements editing of surface.
 *
 * Copyright (c) 2020 Decisions All Rights Reserved
 */
export function FlyOutMenu({ actions, className, ...otherProps }: IFlyOutMenuProps) {
  return (
    <div className={classNames('dpc-flyout-menu', className)} {...otherProps}>
      <DesignerActions theme="white" actions={actions} autoCollapse={false} />
    </div>
  );
}
